<template>
<el-card>
    <template v-slot:header>
    <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-share" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>PPI of TFs</span>
    </div>
    </template>
    <div class="container">
    <el-container>
        <el-main>
        <div id="ppi" style="width:100%;height:500px;"></div> 
        </el-main>
    </el-container>
    </div>
</el-card>
</template>

<script>
export default {
props: {
    species: {
    type: String,
    required: true
    },
    tissue: {
    type: String,
    required: true
    }
},
data() {
    return {
    chartData: [],
    url: "http://183.175.59.4/devenhancer/", // 后端接口地址
    chartGraph: null // echarts 关系图实例
    };
},
mounted() {
    // 初始化 echarts 关系图实例
    this.chartGraph = this.$echarts.init(document.getElementById('ppi'));
    this.handleAnalysis();
},
methods: {
    handleAnalysis() {
    // 发送请求获取后端数据
    const params = { Species: this.species, Tissue: this.tissue };
    this.$axios
        .get(this.url + "tfppi" + "/", { params })
        .then((response) => {
        // 对数据进行处理
        const res = response.data;
        const nodeConnections = {}; // 节点的连接数

        res.forEach((row) => {
            const node1 = row.node1;
            const node2 = row.node2;

            // 统计节点的连接数
            if (!nodeConnections[node1]) {
            nodeConnections[node1] = 0;
            }
            if (!nodeConnections[node2]) {
            nodeConnections[node2] = 0;
            }
            nodeConnections[node1]++;
            nodeConnections[node2]++;
        });
        // 根据连接数对节点进行排序
        const sortedNodes = Object.keys(nodeConnections).sort((a, b) => {
            return nodeConnections[b] - nodeConnections[a];
        });

        // 截取前20个节点
        const topNodes = sortedNodes.slice(0, 20);

        // 构建节点和连线数据
        const nodes = [];
        const links = [];

        topNodes.forEach((nodeName) => {
            nodes.push({ name: nodeName });
        });

        res.forEach((row) => {
            const node1 = row.node1;
            const node2 = row.node2;
            const weight = parseFloat(row.weight);

            if (topNodes.includes(node1) && topNodes.includes(node2)) {
            const node1Index = topNodes.indexOf(node1);
            const node2Index = topNodes.indexOf(node2);

            links.push({ source: node1Index, target: node2Index, weight: weight });
            }
        });

        const graphData = {
            nodes: nodes,
            links: links
        };

        const option = {
            tooltip: {},
            animationDurationUpdate: 1500,
            animationEasingUpdate: 'quinticInOut',
            series: [
            {
                type: 'graph',
                layout: 'circular',// 使用环形布局
                symbolSize: 60,
                roam: true,
                label: {
                show: true,
                position: 'inside',
                formatter: '{b}'
                },
                edgeSymbol: [],
                edgeSymbolSize: [0],
                edgeLabel: {
                fontSize: 14
                },
                itemStyle: {
                    color: '#82B09F'
            },
                data: nodes,
                links: links,
                emphasis: {
                focus: 'adjacency',
                lineStyle: {
                    width: 10
                }
                },
                force: {
                repulsion: 1000,
                edgeLength: [10, 50]
                },
                lineStyle: {
                color: '#3F3F5B',
                curveness: 0.3
                }
            }
            ]
        };
        // 使用 echarts 关系图实例设置选项和数据
        this.chartGraph.setOption(option);
        })
        .catch((error) => {
        console.error(error);
        this.$message.error('Failed to fetch data.');
        });
    },
},
};
</script>

<style scoped>
.custom-button1 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
}
.custom-button2 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
    margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/coreTF/Coretf.vue